import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { TranslateWhatsappTemplateResponseData, TranslateWhatsappTemplateSchema } from "schema"
import z from "zod"

export const useTranslateWhatsappTemplateMutation = () => {
  return useMutation({
    mutationFn: async ({
      languages,
      id,
    }: z.infer<typeof TranslateWhatsappTemplateSchema> & { id: string }) => {
      const { data } = await axios.post<{
        data: z.infer<typeof TranslateWhatsappTemplateResponseData>
      }>(`/integrations/whatsapp/templates/${id}/translate`, {
        languages,
      })
      return data.data
    },
  })
}
